import request from '@/http/request'
export const searchEmu = {
  THESIS: 'thesis', // 论文
  PAPER: 'paper', // 本地文档
  ARTICLE: 'article', // 收藏文章
  BOOK_COMMENT: 'comment', // 书评
  NOTE: 'note', // 笔记
  DRAFT: 'draft', //白板
  FRIEND_SHARE: 'friendShare', // 好友分享
  MINDMAP: 'mindmap', // 脑图
  TIMELINE: 'timeline' // 时间轴
}

export const convertList = (result, tabName) => {
  let list = []
  // 论文
  if (tabName === searchEmu.PAPER) {
    list = result?.paper_list?.list.map((item) => {
      return {
        id: item.paper_id,
        title: item.paper_title,
        url: item.paper_url,
        content_arr: [],
        type: searchEmu.PAPER
      }
    })
  }
  if (tabName === searchEmu.THESIS) {
    list = result?.thesis_list?.list.map((item) => {
      return {
        id: item.paper_id,
        title: item.paper_title,
        url: item.paper_url,
        content_arr: [],
        type: searchEmu.THESIS
      }
    })
  }
  // 文章
  if (tabName === searchEmu.ARTICLE) {
    list = result?.article_list?.list.map((item) => {
      return {
        id: item.id,
        title: item.title,
        url: '',
        content_arr: [],
        type: searchEmu.ARTICLE
      }
    })
  }
  // 书评
  if (tabName === searchEmu.BOOK_COMMENT) {
    list = result?.comment_list?.list.map((item) => {
      return {
        id: item.book_comment_id,
        title: item.main_title,
        url: '',
        content_arr: [],
        type: searchEmu.BOOK_COMMENT
      }
    })
  }
  // 笔记
  if (tabName === searchEmu.NOTE) {
    list = result?.note_list?.list.map((item) => {
      return {
        id: item.note_id,
        title: item.main_title,
        url: '',
        content_arr: [],
        type: searchEmu.NOTE
      }
    })
  }
  if (tabName === searchEmu.DRAFT) {
    list = result?.draft_list.list.map((item) => {
      return {
        id: item.id,
        title: item.title,
        url: '',
        content_arr: [],
        type: searchEmu.DRAFT
      }
    })
  }
  
  // 脑图
  if (tabName === searchEmu.MINDMAP) {
    // 处理搜索结果和普通列表结果
    const mindmapData = result?.mindmap_list?.list || result?.data || result || []
    console.log('🔍 [调试] 脑图原始数据:', result)
    console.log('🔍 [调试] 提取的mindmapData:', mindmapData)
    list = mindmapData.map((item, index) => {
      // 确保每个项目都有唯一的ID
      const uniqueId = item.mind_map_id || `mindmap_${Date.now()}_${index}`
      const processedItem = {
        id: uniqueId,
        mind_map_id: item.mind_map_id, // 保留原始ID用于API调用
        title: item.content || item.title || '未命名脑图',
        url: '',
        content_arr: [],
        type: searchEmu.MINDMAP,
        add_time: item.add_time,
        // 调试信息
        _debug: {
          originalItem: item,
          hasContent: !!item.content,
          hasTitle: !!item.title,
          index: index,
          uniqueId: uniqueId
        }
      }
      console.log(`🔍 [调试] 处理脑图项 ${index}:`, processedItem)
      return processedItem
    }) || []
    console.log('🔍 [调试] 最终脑图列表:', list)
  }
  
  // 好友分享
  if (tabName === searchEmu.FRIEND_SHARE) {
    list = result?.shareList?.map((item) => {
      return {
        id: item.id,
        title: item.title,
        url: item.url,
        content_arr: [{
          current: item.sum_up,
          complete: item.sum_up
        }],
        type: searchEmu.FRIEND_SHARE,
        author: item.author || '匿名好友',
        share_time: item.share_time || item.add_time,
        isShared: true // 标记为分享文章
      }
    }) || []
  }
  
  // 时间轴
  if (tabName === searchEmu.TIMELINE) {
    list = result?.map((item) => {
      return {
        id: item.timeline_id,
        title: item.title,
        content: item.content,
        url: '',
        content_arr: [],
        type: searchEmu.TIMELINE,
        add_time: item.add_time
      }
    }) || []
  }
  
  return list
}

export const getSearchContent = (id, searchKeyword, tabName) => {
  return new Promise((resolve, reject) => {
    const params = {
      query: searchKeyword,
      search_type: tabName
    }
    if (tabName === searchEmu.PAPER) {
      params.paper_id = id
    }
    if (tabName === searchEmu.ARTICLE) {
      params.article_id = id
    }
    if (tabName === searchEmu.BOOK_COMMENT) {
      params.book_comment_id = id
    }
    if (tabName === searchEmu.NOTE) {
      params.note_id = id
    }
    if (tabName === searchEmu.DRAFT) {
      params.draft_id = id
    }
    if (tabName === searchEmu.FRIEND_SHARE) {
      params.share_id = id
    }
    if (tabName === searchEmu.TIMELINE) {
      params.timeline_id = id
    }
    request('api/Paper/searchContentDetail', params).then((result) => {
      const contentArr = result?.content_arr || []
      resolve(contentArr)
    }).catch(() => {
      // eslint-disable-next-line prefer-promise-reject-errors
      reject()
    })
  })
}
